/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_Path_LabelInputs */

const vi_shop_category_path_label = /** @type {(inputs: Shop_Category_Path_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn`)
};

/**

* @param {Shop_Category_Path_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_path_label = /** @type {((inputs?: Shop_Category_Path_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Path_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_path_label(inputs)
});